import type { FundBusinessForLocalGovernmentModel } from '@/features/project/projects/_models/sub-project';
import { convertToNegative } from '@/utils';
import type { z } from 'zod';

type FundBusinessForLocalGovernmentType = z.infer<
  typeof FundBusinessForLocalGovernmentModel
>;

export const getSumOfTheEndOfThePriorFundBalance = ({
  fundBusinessForLocalGovernment,
}: {
  fundBusinessForLocalGovernment: FundBusinessForLocalGovernmentType;
}) => {
  const isAllNull = [
    fundBusinessForLocalGovernment.beginningOfTheFundBalance,
    fundBusinessForLocalGovernment.incomeAmount,
    fundBusinessForLocalGovernment.businessExpense,
    fundBusinessForLocalGovernment.amountReturnedToTheNationalTreasury,
  ].every((v) => v === null || v === undefined);

  if (isAllNull) {
    return {
      totalAmount: null,
      negativeCount: 0,
    };
  }

  const totalAmountTarget = [
    // n-1基金残高
    fundBusinessForLocalGovernment.beginningOfTheFundBalance ?? 0,
    // n年度収入総額
    fundBusinessForLocalGovernment.incomeAmount ?? 0,
    // n年度支出
    convertToNegative(fundBusinessForLocalGovernment.businessExpense),
    // n年度国庫返納額
    convertToNegative(
      fundBusinessForLocalGovernment.amountReturnedToTheNationalTreasury,
    ),
  ];

  const totalAmount = totalAmountTarget.reduce((acc, curr) => {
    return (acc ?? 0) + (curr ?? 0);
  }, 0);

  const negativeCount = [
    totalAmountTarget.some((v) => v < 0) ? 1 : 0,
    fundBusinessForLocalGovernment.negativeBeginningOfTheFundBalanceCount,
    fundBusinessForLocalGovernment.negativeIncomeAmountCount,
    fundBusinessForLocalGovernment.negativeBusinessExpenseCount,
    fundBusinessForLocalGovernment.negativeAmountReturnedToTheNationalTreasuryCount,
  ].reduce((acc, curr) => {
    return (acc ?? 0) + (curr ?? 0);
  }, 0);
  return {
    totalAmount,
    negativeCount,
  };
};
